import { createControlFn } from "../create-control-fn"

const controlNameFieldFn = createControlFn({
  filterValueCb: (value) =>
    !/^\s+/.test(value) && !/[^a-zA-Z-' àáèéìíòóùú,]/.test(value),
})

export { controlNameFieldFn }
